module.exports = __webpack_public_path__ + "static/media/S4.9257d1a8.png";